import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

type Props = {
	data: Pick<PortfolioDetailResponseDTO, "signedAt" | "startAt" | "endAt">;
};

export const DetailDates: FC<Props> = ({ data }) => {
	const { t } = useResource();
	const theme = useTheme();

	if (!data.signedAt && !data.startAt && !data.endAt) {
		return null;
	}

	return (
		<>
			<Typography variant="sectionLabel">
				{t(Resources.DataCard.BasicInfo.additionalInfo)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<DetailRow
					label={t(Resources.PortfolioDetail.SharedLabels.signDate)}
					value={dateFormatter(data.signedAt)}
				/>
				<DetailRow
					label={t(Resources.PortfolioDetail.SharedLabels.beginDate)}
					value={dateFormatter(data.startAt)}
				/>
				<DetailRow
					label={t(Resources.PortfolioDetail.SharedLabels.endDate)}
					value={dateFormatter(data.endAt)}
				/>
			</Stack>
		</>
	);
};
